export function getTagMatchCount(product, selectedTags) {
  if (!selectedTags?.length) return 0;

  return selectedTags.filter((tag) =>
    product.tags?.some((productTag) => productTag.id === tag.id)
  ).length;
}

export function rankProductsByTags(products, selectedTags) {
  if (!selectedTags?.length) return products;

  return products
    .filter((product) => getTagMatchCount(product, selectedTags) > 0)
    .sort(
      (a, b) => getTagMatchCount(b, selectedTags) - getTagMatchCount(a, selectedTags)
    );
}
